<!-- MODAL EDIT PRODUCT -->
<div class="modal fade" id="modalEditProduct" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">

      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
          <i class="bi bi-pencil-square me-2"></i> Editar Producto
        </h5>
        <button class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>

      <form [formGroup]="form" (ngSubmit)="saveChanges()">
        <div class="modal-body">
          <div class="row g-3">

            <div class="col-md-4">
              <label class="form-label">Código</label>
              <input class="form-control" type="number" formControlName="codigo" readonly>
            </div>

            <div class="col-md-4">
              <label class="form-label">Código INE</label>
              <input class="form-control" formControlName="codigoIne">
            </div>

            <div class="col-md-4">
              <label class="form-label">Nombre</label>
              <input class="form-control" formControlName="nombre">
            </div>

            <div class="col-md-4">
              <label class="form-label">Sección</label>
              <input class="form-control" type="number" formControlName="fkSeccion">
            </div>

            <div class="col-md-4">
              <label class="form-label">División</label>
              <input class="form-control" type="number" formControlName="fkDivision">
            </div>

            <div class="col-md-4">
              <label class="form-label">Clase</label>
              <input class="form-control" type="number" formControlName="fkClase">
            </div>

            <div class="col-md-4">
              <label class="form-label">CIIU</label>
              <input class="form-control" formControlName="codigoCiiu">
            </div>

            <div class="col-md-4">
              <label class="form-label">NAEG</label>
              <input class="form-control" formControlName="codigoNaeg">
            </div>

            <div class="col-md-4">
              <label class="form-label">NPG</label>
              <input class="form-control" formControlName="codigoNpg">
            </div>

            <div class="col-md-4">
              <label class="form-label">CCP</label>
              <input class="form-control" formControlName="codigoCcp">
            </div>

            <div class="col-md-8">
              <label class="form-label">Referencia</label>
              <input class="form-control" formControlName="referencia">
            </div>

            <div class="col-md-4">
              <label class="form-label">Estado</label>
              <select class="form-select" formControlName="estado">
                <option value="A">Activo</option>
                <option value="I">Inactivo</option>
              </select>
            </div>

          </div>
        </div>

        <div class="modal-footer d-flex justify-content-between">
          <button class="btn btn-danger" type="button" (click)="openDeleteModal()">
            <i class="bi bi-trash"></i> Eliminar
          </button>

          <div>
            <button class="btn btn-outline-secondary me-2" type="button" data-bs-dismiss="modal">
              Cancelar
            </button>

            <button class="btn btn-primary" type="submit">
              Guardar Cambios
            </button>
          </div>

        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL DELETE PRODUCT -->
<div class="modal fade" id="modalDeleteProduct" tabindex="-1">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">
          <i class="bi bi-exclamation-triangle-fill"></i> Confirmar Eliminación
        </h5>
        <button class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body text-center">
        <p class="fw-semibold">¿Desea eliminar este producto?</p>
        <p class="text-muted">{{ product?.nombre }}</p>
      </div>

      <div class="modal-footer d-flex justify-content-end">
        <button class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button class="btn btn-danger" (click)="confirmDelete()">Eliminar</button>
      </div>

    </div>
  </div>
</div>

<!-- TOASTS -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 99999;">
  <div id="toastSuccessProduct" class="toast text-white bg-success border-0" data-bs-delay="2500" data-bs-autohide="true">
    <div class="d-flex">
      <div class="toast-body">
        <i class="bi bi-check-circle-fill me-2"></i>
        Producto actualizado correctamente.
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
    </div>
  </div>

  <div id="toastDeleteProduct" class="toast text-white bg-danger border-0" data-bs-delay="2500" data-bs-autohide="true">
    <div class="d-flex">
      <div class="toast-body">
        <i class="bi bi-trash-fill me-2"></i>
        Producto eliminado correctamente.
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
    </div>
  </div>

  <div id="toastErrorProduct" class="toast text-white bg-danger border-0" data-bs-delay="2500" data-bs-autohide="true">
    <div class="d-flex">
      <div class="toast-body">
        <i class="bi bi-exclamation-circle-fill me-2"></i>
        Error al procesar la solicitud.
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
    </div>
  </div>
</div>
